<template>
  <div class="addImagesbj">
    <div class="grouping" >
      <van-button v-for="(item, index) in tabbar"
                  :key="index" :name="index"
                  :class="['terminal-btn', { 'selected': activeKey === index }]"
                  icon="/static/images/etv-folder.png"
                  @click="onChange(index)">
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div id="materiallist" class="materiallist abcds">
      <div class="content">
        <div class="photo" :style="{
          height: width + 'px',
          width: width + 'px'
        }">
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" style="display: none;" />
          <img class="up_loading"
               src="/static/images/program/updata.png"
               @click="handleClick"
               style="width: 100%; height: 100%;" />
        </div>
        <div class="materia-item" v-for="(item, index) in materialList" :key="index"
             @click="getselevt(item.checked, index)"
             :style="{
          height: width + 'px',
          width: width + 'px'
        }">
          <div class="checkbox">
            <van-checkbox v-model="item.checked" ></van-checkbox>
          </div>
          <van-list style="width:100%;height: 80%" >
            <van-image :src="item.screenshotUrl"   style="width: 100%;height: 100%;"/>
          </van-list>
          <span class="audit-name">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="btns" >
      <van-button color="#FF5700" size="small" @click="close">{{$t('append_field.cancel')}}</van-button>
      <span>{{$t('append_field.selectedNumber')}} ({{number}})</span>
      <van-button color="#006EFF" size="small" @click="submits">{{$t('append_field.confirm')}}</van-button>
    </div>
    <!-- 禁用上传弹窗   -->
    <van-dialog v-model="showUploadFileDialog" :title="$t('append_field.getUploadendTim')">
      <div class="dialog-content">
        <span>{{ uploadFileText }}</span>
        <span>{{ $t('append_field.getUploadstartTime_tip') }}</span>
      </div>
    </van-dialog>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{msg}}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant';
import qs from 'qs';
import axios from "axios";
import {EventBus} from "@/store/eventBus";
import {handleUploadFile, fileTypeList, upFileImage} from "@/utils/handleUpload";

function parseDateTime(dateTimeStr) {
  return new Date(dateTimeStr)
}
export default {
  name: 'addImages',
  data() {
    return {
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      FolderIndex: 0,
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 0,
      show1: true,
      msg: '',
      allowUpload:false,
      showUploadFileDialog:false,
      uploadFileText:'',
      uploadType:"",//这个是来判断上传方式的，上面那个是返回素材是什么方式上传的，然后来决定要不要拼接
      }
  },
  mounted() {
    this.width = document.getElementById('materiallist').clientWidth / 4 - 2
    const materiallist = document.getElementsByClassName('abcds')[0]
    materiallist.addEventListener('scroll', this.handleScroll)
    this.getFolder(0)
    this.getmaterial(1)
  },
  methods: {
    errImg(val,url) {
      const maxRetries = 3; // 最大重试次数
      const imgSrc = this.upFileUrl + url
      const retries = val.target.dataset.retries ? parseInt(val.target.dataset.retries) : 0;

      if (retries < maxRetries) {
        val.target.dataset.retries = retries + 1; // 增加重试次数
        // 延迟一段时间后重新加载图片
        setTimeout(() => {
          val.target.src = imgSrc ? imgSrc : "";
        }, 1000); // 1秒后重试
      } else {
        val.target.src = ' '; // 超过最大重试次数，使用默认图片
      }

      // 如果图片显示不正常，将其设置为空字符串或默认图片
      if (val.target.src && !val.target.complete) {
        val.target.src = ' ';
      }
    },
    getFolder(index) {
      this.msg = this.$t('append_field.loadingb')
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: 'img',
          type: 'select',
          id: '',
          filterType:1
        })).then(res => {
          if (res.data.code === 0) {
            localStorage.setItem("lastSize",res.data.data.lastSize)
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children
        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId
      })
    },
    close() {
      this.$emit('close')
    },
    submits() {
      if (this.selectImg.length === 0) {
          Toast(this.$t('append_field.selectImage'))
          return
      } else if (this.selectImg.length > 1) {
          Toast(this.$t('append_field.onlySelectOneImage'))
          return
      }
        this.$emit('setImages', this.selectImg[0])
      },
      upImage() {
    },

    onChange(index) {
        if (this.activeKey !== index) { // 避免不必要的变更
          this.activeKey = index // 更新活动键
        }
        this.FolderIndex = index
        this.materialList = []
        this.groupingName = this.tabbar[index].name
        this.getmaterial(this.tabbar[index].mfId)
        this.id = this.tabbar[index].mfId
        this.show1 = true
        this.msg = this.$t('append_field.loadinga')
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },
    getmaterial(id) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: 'img',
        pageNum: 1,
        pageSize: 99999,
        filterType: 1
      })).then(res => {
        if (res.data.code === 0) {
            this.number =0
            this.index = 0
            this.allmaterialList = res.data.data.materialList
          this.allmaterialList.map(res => {
            res.checked = false
            res.screenshotUrl=this.getUrl(res.screenshotUrl)
            })
          if(this.allmaterialList.length>100){
            this.materialList = this.allmaterialList.slice(this.index, this.index + 28)
          }else {
            this.materialList= this.allmaterialList
          }
          this.$nextTick(() => {
              this.show1 = false
            })
        }
        })
    },
    handleScroll() {
      //滚动条
        const scrollHeight = document.getElementsByClassName('abcds')[0].scrollTop
        let clientHeight = document.getElementsByClassName('content')[0].clientHeight
        let doch = window.screen.height
      //真实高度
      if (clientHeight - doch - scrollHeight < 40) {
        if (this.allmaterialList.slice(this.index * 28, this.index * 28 + 28).length < 28) {
            return
        }
          this.index++
          this.materialList = [...new Set([...this.materialList, ...this.allmaterialList.slice(this.index * 28, this.index * 28 + 28)])]
      }
      },
    getselevt(sele, index) {
      /*  this.materialList[index].checked = sele
        this.$set(this.materialList, index, this.materialList[index])
      this.selectImg = this.materialList.filter(res => {
          return res.checked
        })
      this.number = this.selectImg.length*/
      // 取消所有项目的选择状态
      this.materialList.forEach((item, i) => {
        if (i !== index) {
          item.checked = false
        }
      })

      // 设置当前项目的选择状态
      this.materialList[index].checked = !sele

      // 清空 selectDoc 并只添加当前选中的项目
      this.selectImg = []
      if (this.materialList[index].checked) {
        this.selectImg.push(this.materialList[index])
      }

      // 更新 number
      this.number = this.selectImg.length

      // 使用 $set 确保 Vue 能检测到数组的变化
      this.$set(this.materialList, index, this.materialList[index])
    },
    // 点击 div 触发的事件
    async handleClick() {
      try {
        const isAllowed = await this.getUploadSet()
        if (isAllowed) {
          this.allowUpload = true
          // 手动触发文件选择对话框,ios需要用setTimeout强制触发
          setTimeout(() => {
            this.$refs.fileInput.click()
          }, 0)
        } else {
          this.allowUpload = false
        }
      } catch (error) {
        Toast(this.$t('append_field.getUploadSet_tip')) // 处理 AJAX 请求失败的情况
        this.allowUpload = false
      }
    },
    // 文件选择变化事件处理
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        const lastSize = localStorage.getItem("lastSize") // 获取剩余空间大小
        const fileSizeInMB = file.size / 1024 / 1024 // 计算文件大小（转换为MB）
        if (!fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.unsupportedFormat'))
          return false
        }
        if (lastSize < fileSizeInMB) {
          // 如果文件大小超过剩余空间，显示提示信息
          const remainingSpace = lastSize // 剩余空间大小
          const message = this.$t('append_field.last_size') + ' ' + remainingSpace + 'MB' // 构造包含剩余空间大小的消息
          Toast(message, 'fail') // 显示提示
          return
        }
        if (fileSizeInMB < 38 / 1024 && ["png", "jpg", "jpeg", "gif"].includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.file_less_38'))
          return false
        }
        /*判断是要本地上传还是cos*/
        if (this.uploadType === 1) {
          this.show1 = true
          EventBus.$off('upload-success')
          //先获取存储桶信息
          await handleUploadFile(this.$ajax)
          await upFileImage(file, this.id, this.$ajax)
          EventBus.$on('upload-success', this.handleUploadSuccess)
        } else {
          this.uploadFile(file)
        }
      }
    },
    handleUploadSuccess(){
      this.getFolder(this.FolderIndex)
      this.getmaterial(this.id)
    },
    // 文件上传处理
    uploadFile(file) {
      this.loading_show = true
      setTimeout(() => {
        if (fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          this.loading_show = false
          this.show2 = true
          this.complete = 0
          const formData = new FormData()

          this.fileName = file.name
          this.fileSize = (file.size / 1024 / 1024).toFixed(2)
          formData.append('files', file)
          formData.append('id', this.id)

          let cancelToken = axios.CancelToken // Axios使我修改axios原型链了。
          this.source = cancelToken.source()

          this.$ajax.post(this.upFileUrl + 'etv/insertMaterial.json', formData, {
            headers: {
              'contentType': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
              this.complete = complete
            },
            cancelToken: this.source.token,
          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.materialList = []
              this.handleUploadSuccess()
              this.show2 = false
            } else {
              this.show2 = false
              Toast(res.data.msg)
            }
          }).catch(() => {
            this.show2 = false
            this.loading_show = false
            Toast(this.$t('append_field.cancelAllUploads'))
          })
        } else {
          this.loading_show = false
          Toast(this.$t('append_field.unsupportedFormat'))
        }
      }, 300)
    },
    // 判断是否在禁用上传素材时间
    getUploadSet() {
      return new Promise((resolve, reject) => {
        this.$ajax.post('/etv/getUploadSet.json').then(res => {
          console.log(res.data.code)
          if (res.data.code === 0) {
            const currentTime = new Date() // 获取当前时间
            this.uploadType=res.data.data.uploadType //获取上传类型 上传类型 0-本地 1-cos上传*/
            const startTime = parseDateTime(res.data.data.startTime) // 解析接口返回的开始时间
            const endTime = parseDateTime(res.data.data.endTime) // 解析接口返回的结束时间
            const formattedStartTime = startTime.toLocaleString()// 格式化开始时间
            const formattedEndTime = endTime.toLocaleString() // 格式化结束时间
            // 检查当前时间是否在禁止上传的时间段内
            if (currentTime >= startTime && currentTime <= endTime) {
              this.showUploadFileDialog=true
              this.uploadFileText=`${formattedStartTime}—${formattedEndTime}`
              resolve(false) // 不允许上传
            } else {
              resolve(true) // 允许上传
            }
          } else {
            Toast(this.$t('append_field.getUploadSet_tip'))
            resolve(false) // 出现错误，不允许上传
          }
        }).catch(error => {
          reject(error) // AJAX 请求失败，传递错误
        })
      })
    },
    getUrl(url) {
      if (!url) {
        return url
      }
      const isHttpUrl = url.startsWith("http")
      if (isHttpUrl) {
        return url
      }
      // 如果不是 HTTP URL，拼接基础 URL 并返回
      return this.upFileUrl + url
    }
  },
  destroyed() {
      this.materialList = []
  },
  }
</script>

<style lang="scss">
@import "../../public/static/css/app";

.addImagesbj {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  .select-groupings{
    height: calc(100% - 380px);
  }
  .van-dialog__content{
    height: calc(100% - 40px - 60px);
    overflow-y: auto;
  }
  .dialog-content {
    margin: 45px 16px;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }
  .dialog-content span {
    margin-bottom: 8px;
    word-break: break-word;
  }
  .van-icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .materiallist {
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 75px;
    bottom: 60px;
    overflow-y: auto; /* 确保内容可以垂直滚动 */

    .content {
      height: 100%;
      position: absolute;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: flex-start;
    }
    .up_loading {
     /* padding: 20px 32px 30px 28px;
      margin-top: 5px;*/
    }
    .photo {
      box-sizing: border-box;
      padding: 2px;

      .van-uploader__upload-icon {
        font-size: 48px;
      }

      .van-uploader {
        width: 100%;
        height: 100%;
        border: none;

        .van-uploader__wrapper {
          width: inherit;
          height: inherit;

          .van-uploader__upload {
            width: inherit;
            height: inherit;
            margin: 0 !important;
            border: none;
          }
        }
      }

      .updata-centnt {
        width: 100%;
        height: 100%;
        border-radius: 5px;

        .updata {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          background: #ffffff;

          .updata-img {
            width: 40%;
            height: 40%;
            margin-bottom: 10px;
          }
        }
      }

    }


    .materia-item {
      position: relative;
      padding: 2px;
      box-sizing: border-box;

      .checkbox {
        z-index: 2;
        position: absolute;
        top: 1px;
        right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
      .audit-name{
        display: inline-block;
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
        width: 100%;
        line-height: 22px; /* 设置与高度相同的行高 */
        font-size: 16px;
        color: #131212;
      }
    }
  }

  .grouping {
    display: flex;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 75px;
    gap: 10px; /* 按钮之间的间隔 */
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid $uni-border-bottom-color;
    overflow-x: auto; /* 水平滚动 */
    .terminal-btn{
      flex: 1 1 auto; /* 自适应宽度 */
      white-space: nowrap; /* 防止文字换行 */
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }
    .van-button{
      width: 200px !important;
    }
    .van-button__text{
      display: block;
      max-width: 100%;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .selected {
      background-color: #006EFF ;
      color: white;
    }
  }
  .btns {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%; /* 确保容器宽度充满屏幕 */
    height: 44px;
    justify-content: space-between; /* 子元素平均分布在容器中 */
    align-items: center; /* 垂直居中对齐 */
    background-color: white; /* 可选：为了清晰显示 */
    box-sizing: border-box; /* 防止边框或内边距影响布局 */
    padding: 0 16px; /* 可选：给两侧添加一些内边距 */
  }
  .btns > * {

    text-align: center; /* 文本居中对齐 */
  }
  .van-sidebar {
    width: 100%;
  }
}
</style>
